import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./AdminModalPortal.css";

export default function AdminModalPortal({
  isOpen,
  onClose,
  closeDisabled = false,
  ariaLabel,
  children,
  dialogClassName = "",
}) {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const frame = window.requestAnimationFrame(() => dialogRef.current?.focus());

    return () => {
      window.cancelAnimationFrame(frame);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape" && !closeDisabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown, true);

    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [closeDisabled, isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div className="admin-modal-portal__overlay" role="presentation">
      <div
        ref={dialogRef}
        className={`admin-modal-portal__dialog ${dialogClassName}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
        tabIndex={-1}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
